module.exports = __webpack_public_path__ + "static/img/3_1_2_1.127ab7ee.jpg";